import * as Sentry from "@sentry/react";
import {
    createBrowserRouter,
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from "react-router-dom";
import * as React from 'react';
import { getAppConfig } from "./config";

const { sentry } = getAppConfig();

if (sentry && sentry.dsn && sentry.env) {
  Sentry.init({
    dsn: sentry.dsn,
    environment: sentry.env,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect: React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
      }),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    replaysSessionSampleRate: 0.1,
    tracesSampleRate: 1.0,
  });
}

export const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(
  createBrowserRouter,
);
